import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import history from "../History/History";
import HomePage from "./HomePage";
import PublicRoute from "./Route/PublicRoute";
import Signin from "./Signin";
import PrivateRoute from "./Route/PrivateRoute";
import Main from "./Main";
import TermCondition from "./TermCondition";
import Privacy from "./Privacy";
import BlogDetails from "./BlogDetails";
import ScrollToTop from "./ScrollToTop";
import Blogs from "./Blogs";
import PaymentInvoice from "./PaymentInvoice";
import AboutUs from "./AboutUs";
import InventoryFeature from "./InventoryFeature/InventoryFeature";
import PurchaseFeature from "./PurchaseFeature/PurchaseFeature";
import SalesFeature from "./SalesFeature/SalesFeature";
import ContactUs from "./contactUS/ContactUs";
import RefundAndCancellation from "./RefundAndCancellation";
import RequestDemo from "./demoQuery/DemoQuery";
import ServiceFeature from "./ServiceFeature/ServiceFeature";
import PaymentFeature from "./PaymentFeature/PaymentFeature";
import MaterialPlanning from "./MaterialPlanning/MaterialPlanning";
import BOMFeature from "./BOMFeature/BOMFeature";
import LandingPageComponents from "./LandingPage"
import ProductionManagement from "./ProuctionFeature/ProductionManagement";
import JobWorkManagement from "./JobWorkFeature/JobWorkManagement";
import DownloadPdf from "../../Dashboard/Components/previewDocument/DownloadPdf";
import DownloadGateEntryPdf from "../../Dashboard/Components/gate-entry/DownloadGateEntryPdf";


const AppRoutes: React.FC = () => {
  return (
    <Router>
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<PublicRoute><HomePage /></PublicRoute>} />
          <Route path="/landing-page" element={<PublicRoute><LandingPageComponents/></PublicRoute>} />
          <Route path="/download-pdf" element={<PublicRoute><DownloadPdf /></PublicRoute>} />
          <Route path="/download-gate-entry-pdf" element={<PublicRoute><DownloadGateEntryPdf /></PublicRoute>} />
          <Route path="/sign-in" element={<PublicRoute><Signin /></PublicRoute>} />
          <Route path="/sign-up" element={<PublicRoute><Signin /></PublicRoute>} />
          <Route path="/forgot-password" element={<PublicRoute><Signin /></PublicRoute>} />
          <Route path="/reset-password" element={<PublicRoute><Signin /></PublicRoute>} />
          <Route path="/login" element={<PublicRoute><Signin /></PublicRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/storeWiseItems" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/categoryWiseItems" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/stockAgeingItems" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/stockLevelAnalysisItems" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/outOfStockItems" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/fastSlowMovingItems" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/onTimeDelayProductionItems" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/workOrderStatusItems" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/salesDashboardDetails" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/buyer_supplier" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/items" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/stores" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/batchcode" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/inventoryapproval" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/inventoryPreview" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/service/documentServices" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/service/documentServicesConfirmation" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/listOfServices" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/user_management" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/team_management" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/general" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/terms-and-condition" element={<TermCondition />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/our-blogs" element={<PublicRoute><Blogs /></PublicRoute>} />
          <Route path="/manage_blogs" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/permissions" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/blog_details/:id/:title" element={<PublicRoute><BlogDetails /></PublicRoute>} />
          <Route path="/sales/documents" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/purchase/documents" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/docs_approval" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/bill-of-material" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/bom_approval" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/production" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/view_production" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/view-bulk-production" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/new_work_order" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/create_bill_of_material" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/material_planning" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/order_planning_table" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/minimum_stock_planning_table" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/bom_based_planning_table" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/previewBOM" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/integrations" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/sales_transaction" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/purchase_transaction" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/gate_entries" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/previewGateEntry" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/reports" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/create_document" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/create_gate_entry" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/update_document" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/previewDocument" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/servicepreviewDocument" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/comments" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/query" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/demoRequest" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/newsLetters" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/delete-company-data" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/timeline" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/purchase_timeline" element={<PrivateRoute><Main /></PrivateRoute>} />
          <Route path="/payment-invoice" element={<PublicRoute><PaymentInvoice /></PublicRoute>} />
          <Route path="/about-us" element={<PublicRoute><AboutUs /></PublicRoute>} />
          <Route path="/services/inventory-management" element={<PublicRoute><InventoryFeature /></PublicRoute>} />
          <Route path="/services/sales-management" element={<PublicRoute><SalesFeature /></PublicRoute>} />
          <Route path="/services/purchase-management" element={<PublicRoute><PurchaseFeature /></PublicRoute>} />
          <Route path="/services/service-management" element={<PublicRoute><ServiceFeature /></PublicRoute>} />
          <Route path="/services/payment-management" element={<PublicRoute><PaymentFeature /></PublicRoute>} />
          <Route path="/services/material-planning" element={<PublicRoute><MaterialPlanning /></PublicRoute>} />
          <Route path="/services/bom-management" element={<PublicRoute><BOMFeature /></PublicRoute>} />
          <Route path="/services/production-management" element={<PublicRoute><ProductionManagement /></PublicRoute>} />
          <Route path="/services/jobwork-management" element={<PublicRoute><JobWorkManagement /></PublicRoute>} />
          <Route path="/contact-us" element={<PublicRoute><ContactUs /></PublicRoute>} />
          <Route path="/requestdemo" element={<PublicRoute><RequestDemo /></PublicRoute>} />
          <Route path="/refund-cancellation" element={<PublicRoute><RefundAndCancellation /></PublicRoute>} />
        </Routes>
      </ScrollToTop>
    </Router>
  );
};

export default AppRoutes;
